import { Theme } from '@mirai/ui';

const ITEMS_PER_COLUMN = 18;
const ITEM_WIDTH = 300;
const MAX_COLUMNS = 3;
const THEME_KEY = '--mirai-places';

export const calcColumns = ({ dataSource: { length: items } = [], device: { width: deviceWidth } = {} } = {}) => {
  const { ItemsPerColumn = ITEMS_PER_COLUMN, ItemWidth: itemWidth = ITEM_WIDTH } = Theme.get(THEME_KEY);
  const itemsPerColumn = Number(ItemsPerColumn);

  let columns = items > itemsPerColumn ? Math.ceil(items / itemsPerColumn) : undefined;
  if (columns * itemWidth > deviceWidth * 0.8 || columns > MAX_COLUMNS) columns = 1;

  return columns;
};
